module.exports = __webpack_public_path__ + "static/media/celfocus.5d7b5ebd.png";